import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth0 } from "../hooks/react-auth0-spa";

import { API_URL } from "../constants/constants";

export const useStatisticsAPI = (initialUser = "") => {
  // console.log(initialUser);
  const [user, setUser] = useState(initialUser);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { getTokenSilently, user: user2 } = useAuth0();

  useEffect(() => {
    const fetchStatistics = async () => {
      setIsError(false);
      setIsLoading(true);
      try {
        const t = await getTokenSilently();
        const r = await axios.get(API_URL + `/envios/${user2.sub}`, {
          headers: {
            // "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${t}`
          }
        });
        setData(r.data);
        // console.log(r.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      }
      setIsLoading(false);
    };
    fetchStatistics();
    // eslint-disable-next-line
  }, [user]);

  return [{ data, isLoading, isError }, setUser];
};

export default useStatisticsAPI;
